import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=2a1b608e&scoped=true&"
import script from "./SearchWidget.vue?vue&type=script&lang=ts&"
export * from "./SearchWidget.vue?vue&type=script&lang=ts&"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=2a1b608e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b608e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a1b608e', component.options)
    } else {
      api.reload('2a1b608e', component.options)
    }
    module.hot.accept("./SearchWidget.vue?vue&type=template&id=2a1b608e&scoped=true&", function () {
      api.rerender('2a1b608e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/SearchWidget.vue"
export default component.exports